import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react'
import AuthApiList from './auth-api-list/AuthApiList';
import LiveStreamApiList from './live-stream-api-list/LiveStreamApiList';
import TwoWayCommunicationApiList from './two-way-communication-api-list/TwoWayCommunicationApiList';
import AlertVideoApiList from './alert-video-api-list/AlertVideoApiList';
import VehicleApiList from './vehicle-api-list/VehicleApiList';
import SdVideoOnDemandApiList from './get-sd-video-on-demand/SdVideoOnDemandApiList';
import SdVideoPlaybackApiList from './sd-video-playback-api-list/SdVideoPlaybackApiList';
import SdVideoDownloadApiList from './sd-video-download-api-list/SdVideoDownloadApiList';
import CameraDetailsApiList from './camera-details-api-list/CameraDetailsApiList';
import VehicleListApiList from './vehicle-list-api-list/VehicleListApiList';
import AlertTypesApiList from './alert-types-list/AlertTypesApiList';
import TimestampFormatApiList from './timestamp-format-list/TimestampFormatApiList';
import StatusCodesApiList from './status-codes-list/StatusCodesApiList';

const SideNavigationLists = () => {
    return (
        <Box sx={{ marginTop: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography
                variant="body2"
                fontWeight={400}
                fontSize={14}
                sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() => {
                    const introElement = document.getElementById("intro");
                    if (introElement) {
                        introElement.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                }}
            >
                Introduction
            </Typography>
            <AuthApiList />
            {/* <VehicleApiList /> */}
            <LiveStreamApiList />
            <TwoWayCommunicationApiList />
            <AlertVideoApiList />
            <SdVideoOnDemandApiList />
            <SdVideoPlaybackApiList />
            <SdVideoDownloadApiList />
            <CameraDetailsApiList />
            <VehicleListApiList />
            <AlertTypesApiList />
            <TimestampFormatApiList />
            <StatusCodesApiList />
        </Box>
    )
}

export default SideNavigationLists